import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/PresentationHomogene.css';

const Benevoles = () => {
    const navigate = useNavigate();

    const handleRejoindreClick = () => {
        navigate('/contact');
        window.scrollTo(0, 0);
    };
    return (
        <div className='presentation-section benevoles-section'>
            <div className='presentation-card'>
                <div className='section-header'>
                    <h1 className='section-title'>Les Bénévoles de l'Amicale de la Gare de Trôo</h1>
                </div>
                
                <div className='section-content'>
                    <p className='benevoles-intro'>
                        Toujours dans une bonne ambiance, les rôles des bénévoles sont multiples :
                    </p>
                    
                    <div className='benevoles-list'>
                        <div className='benevole-item'>
                            <div className='benevole-number'>1</div>
                            <p className='benevole-text'>
                                Accueil des passagers du TTVL lors des arrêts du train au musée de la gare de Trôo
                            </p>
                        </div>
                        
                        <div className='benevole-item'>
                            <div className='benevole-number'>2</div>
                            <p className='benevole-text'>
                                Animation des ateliers modélisme
                            </p>
                        </div>
                        
                        <div className='benevole-item'>
                            <div className='benevole-number'>3</div>
                            <p className='benevole-text'>
                                Entretien de la gare et de ses alentours
                            </p>
                        </div>
                        
                        <div className='benevole-item'>
                            <div className='benevole-number'>4</div>
                            <p className='benevole-text'>
                                Organisation de manifestations diverses (repas, voyages,...)
                            </p>
                        </div>
                    </div>
                    
                    <button className='benevoles-cta' onClick={handleRejoindreClick}>
                        Rejoignez-nous
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Benevoles;